<div class="text-20" class="import__header">
  Import Chapters
</div>

<app-gallery-container
  class="import__content"
  selectLabel="Import"
  (selectBookmark)="handleSelect($event)"
  [checkable]="false"
  [loading]="loading$ | async"
  [results]="results$ | async" 
  [showActions]="false"
  [viewMode]="viewMode$ | async">
  <ng-template #galleryTags let-item>
      <app-list listType="commafied">
          <!-- Premium -->
          <app-list-item *ngIf="item.premium && !(isPremiumUser$ | async)">
              <app-icon icon="lock"></app-icon> Premium
          </app-list-item>

          <!-- Animated -->
          <app-list-item *ngIf="item.animated">
              Animated
          </app-list-item>

          <!-- Tour -->
          <app-list-item *ngIf="item.tour">
              Tour
          </app-list-item>
      </app-list>
  </ng-template>
</app-gallery-container>